
import XHeader from 'vux/src/components/x-header/index.vue'
import Drawer from 'vux/src/components/drawer/index.vue'

import school from './components/school.json'
import forum from './components/forum.json'

export default {
name: 'app',
components: {
XHeader,Drawer
},
data(){
return{
drawerVisibility: false,
showMode:'push',
check:'',
schools:school,
forums:forum,
type1:false,
type2:false
}
},
methods:{
isShowNav () {
if (this.entryUrl.indexOf('hide-nav') > -1) {
return false
}
return true
},
goBack(){
history.go(-1);
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue